(() => {
    const SKIP_DRAFT = new Set([
        "csrf_token",
        "recaptcha_token",
        "action",
        "aceitoTermos",
    ]);

    function qs(root, selector) {
        return root.querySelector(selector);
    }

    function qsa(root, selector) {
        return [...root.querySelectorAll(selector)];
    }

    function getDraftKey(root) {
        return root.getAttribute("data-draft-key") || "motiveacao.orcamento.draft.v1";
    }

    function readDraft(root) {
        try {
            const raw = window.localStorage.getItem(getDraftKey(root));
            const data = raw ? JSON.parse(raw) : {};
            if (data && typeof data === "object" && data.companyLocationVersion !== 1) {
                delete data.cidade;
                delete data.estado;
                if (data.cep) delete data.localEvento;
                delete data.cep;
            }
            return data;
        } catch (error) {
            return {};
        }
    }

    function writeDraft(root, form) {
        const data = readDraft(root);
        const skipTypes = new Set(["checkbox", "file"]);
        qsa(form, "input, select, textarea").forEach((field) => {
            if (!field.name || SKIP_DRAFT.has(field.name) || skipTypes.has(field.type)) {
                return;
            }
            data[field.name] = field.value;
        });
        const livre = qs(root, "[data-orcamento-tema-livre]");
        data.temasInteresse = (livre?.value || "").trim();
        data.companyLocationVersion = 1;
        delete data.cep;
        data.step = Number(root.dataset.currentStep || 1);
        try {
            window.localStorage.setItem(getDraftKey(root), JSON.stringify(data));
        } catch (error) {
            /* quota / private mode */
        }
    }

    function clearDraft(root) {
        try {
            window.localStorage.removeItem(getDraftKey(root));
        } catch (error) {
            /* private mode */
        }
    }

    function syncTemaField(root) {
        const temaField = qs(root, "[data-orcamento-tema]");
        const livre = qs(root, "[data-orcamento-tema-livre]");
        if (!temaField || !livre) {
            return;
        }
        const value = (livre.value || "").trim();
        if (value) {
            temaField.value = value;
        }
    }

    function appendTemaToLivre(root, label) {
        const livre = qs(root, "[data-orcamento-tema-livre]");
        const value = String(label || "").trim();
        if (!livre || !value) {
            return;
        }
        const current = String(livre.value || "")
            .split(",")
            .map((item) => item.trim())
            .filter(Boolean);
        if (!current.some((item) => item.toLowerCase() === value.toLowerCase())) {
            current.push(value);
        }
        livre.value = current.join(", ");
        syncTemaField(root);
        const wrap = fieldWrap(livre) || qs(root, "[data-orcamento-interest]");
        wrap?.classList.remove("has-error");
        livre.removeAttribute("aria-invalid");
    }

    function commitTemasInteresse(root) {
        const livre = qs(root, "[data-orcamento-tema-livre]");
        const value = (livre?.value || "").trim();
        const temaEvento = qs(root, "[name=temaEvento]");
        if (temaEvento && value && !temaEvento.value.trim()) {
            temaEvento.value = value;
        }
        syncTemaField(root);
        return value;
    }

    function syncSelect(select) {
        const wrap = select.closest("[data-site-select]");
        const valueNode = wrap?.querySelector(".site-select-value");
        const option = [...select.options].find((item) => item.value === select.value);
        if (valueNode) {
            valueNode.textContent = option?.textContent?.trim() || valueNode.textContent;
        }
        wrap?.querySelectorAll("[role='option']").forEach((item) => {
            item.classList.toggle("is-selected", item.getAttribute("data-value") === select.value);
        });
    }

    function restoreDraft(root, form) {
        const data = readDraft(root);
        if (!data || typeof data !== "object") {
            return 1;
        }
        qsa(form, "input, select, textarea").forEach((field) => {
            if (!field.name || SKIP_DRAFT.has(field.name) || field.type === "checkbox" || field.type === "file") {
                return;
            }
            if (data[field.name] == null || data[field.name] === "") {
                return;
            }
            field.value = String(data[field.name]);
            if (field.tagName === "SELECT") {
                syncSelect(field);
            }
        });
        const temasInteresse = typeof data.temasInteresse === "string" ? data.temasInteresse : "";
        const livre = qs(root, "[data-orcamento-tema-livre]");
        if (livre && temasInteresse) {
            livre.value = temasInteresse;
        } else if (Array.isArray(data.temas) && data.temas.length && livre) {
            livre.value = data.temas.map((tema) => String(tema || "").trim()).filter(Boolean).join(", ");
        }
        syncTemaField(root);
        return Number(data.step) > 1 ? Number(data.step) : 1;
    }

    function messageOf(root, key, fallback) {
        return (root.getAttribute(`data-${key}`) || fallback || "").trim();
    }

    function fieldWrap(field) {
        return field.closest(".form-orcamento-field, fieldset.form-orcamento-field");
    }

    function setFieldMessage(wrap, text) {
        const error = wrap?.querySelector(".form-orcamento-error");
        if (error && text) {
            error.textContent = text;
        }
    }

    function phoneDigits(value) {
        return String(value || "").replace(/\D/g, "");
    }

    function isFreeformPhone(value) {
        const raw = String(value || "").trim();
        return /[A-Za-z+]/.test(raw) || /ramal/i.test(raw);
    }

    function isBrPhone(value) {
        const digits = phoneDigits(value);
        if (digits.length === 10) {
            return /^[1-9]\d{9}$/.test(digits);
        }
        if (digits.length === 11) {
            return /^[1-9]\d9\d{8}$/.test(digits);
        }
        return false;
    }

    function formatBrPhone(value) {
        const raw = String(value || "");
        if (isFreeformPhone(raw)) {
            return raw;
        }
        const digits = phoneDigits(raw);
        if (!digits) {
            return "";
        }
        const local = digits.slice(0, 11);
        let display = "";
        if (local.length <= 2) {
            display = `(${local}`;
        } else if (local.length <= 6) {
            display = `(${local.slice(0, 2)}) ${local.slice(2)}`;
        } else if (local.length <= 10) {
            display = `(${local.slice(0, 2)}) ${local.slice(2, 6)}-${local.slice(6)}`;
        } else {
            display = `(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`;
        }
        return digits.length > 11 ? `${display} ${digits.slice(11)}` : display;
    }

    function applyPhoneMask(input) {
        if (!(input instanceof HTMLInputElement)) {
            return;
        }
        const next = formatBrPhone(input.value);
        if (input.value !== next) {
            input.value = next;
        }
    }

    function isEmailValue(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
    }

    function isPastDate(field) {
        const min = field.getAttribute("min");
        const value = (field.value || "").trim();
        return Boolean(min && value && value < min);
    }

    function fieldResult(root, field) {
        const wrap = fieldWrap(field);
        const rule = wrap?.getAttribute("data-orcamento-rule") || "";
        const value = (field.value || "").trim();
        const required = field.required || field.hasAttribute("required");
        const requiredMsg = messageOf(root, "error-required", "Preencha este campo para continuar.");

        if (field.type === "checkbox") {
            if (required && !field.checked) {
                return { ok: false, warn: false, message: messageOf(root, "error-termos", requiredMsg) };
            }
            return { ok: true, warn: false, message: "" };
        }

        if (required && !value) {
            return { ok: false, warn: false, message: requiredMsg };
        }

        if (!value) {
            return { ok: true, warn: false, message: "" };
        }

        if (rule === "email" || field.type === "email") {
            if (!isEmailValue(value)) {
                return { ok: false, warn: false, message: messageOf(root, "error-email", requiredMsg) };
            }
        }

        if (rule === "date" || field.type === "date") {
            if (isPastDate(field)) {
                return { ok: false, warn: false, message: messageOf(root, "error-date", requiredMsg) };
            }
        }

        if (rule === "phone" || field.name === "telefone") {
            if (!isBrPhone(value)) {
                return {
                    ok: true,
                    warn: true,
                    message: messageOf(root, "phone-warn", ""),
                };
            }
        }

        return { ok: true, warn: false, message: "" };
    }

    function paintField(wrap, field, result, show) {
        if (!wrap) {
            return result.ok;
        }
        wrap.classList.toggle("has-error", show && !result.ok);
        wrap.classList.toggle("has-warn", show && result.ok && result.warn);
        if (!result.ok) {
            setFieldMessage(wrap, result.message);
        }
        const warn = wrap.querySelector("[data-orcamento-phone-warn]");
        if (warn && result.warn && result.message) {
            warn.textContent = result.message;
        }
        if (field) {
            if (show && !result.ok) {
                field.setAttribute("aria-invalid", "true");
            } else {
                field.removeAttribute("aria-invalid");
            }
        }
        return result.ok;
    }

    function validateField(root, field, show = true) {
        const wrap = fieldWrap(field);
        const result = fieldResult(root, field);
        return paintField(wrap, field, result, show);
    }

    function validateStep(root, step) {
        const stepEl = qs(root, `.form-orcamento-step[data-step="${step}"]`);
        if (!stepEl) {
            return true;
        }
        let ok = true;
        qsa(stepEl, "input:not([type='hidden']), select, textarea").forEach((field) => {
            if (!validateField(root, field, true)) {
                ok = false;
            }
        });
        if (step === 1) {
            const interestValue = commitTemasInteresse(root);
            const interest = qs(root, "[data-orcamento-interest]");
            const wrap = interest?.closest(".form-orcamento-field, fieldset.form-orcamento-field") || interest;
            const livre = qs(root, "[data-orcamento-tema-livre]");
            if (!interestValue) {
                ok = false;
                wrap?.classList.add("has-error");
                setFieldMessage(wrap, messageOf(root, "error-temas", messageOf(root, "error-required", "")));
                if (livre) {
                    livre.setAttribute("aria-invalid", "true");
                }
            } else {
                wrap?.classList.remove("has-error");
                livre?.removeAttribute("aria-invalid");
            }
        }
        if (!ok) {
            const firstInvalid = qs(stepEl, ".has-error input, .has-error select, .has-error textarea, .has-error button");
            const focusTarget = firstInvalid?.tagName === "SELECT"
                ? firstInvalid.closest("[data-site-select]")?.querySelector(".site-select-trigger")
                : firstInvalid;
            focusTarget?.focus();
        }
        return ok;
    }

    function bindFieldValidation(root, form) {
        form.addEventListener("blur", (event) => {
            const field = event.target;
            if (!(field instanceof HTMLElement) || !field.matches("input, select, textarea")) {
                return;
            }
            if (field.matches("[data-orcamento-tema-livre]")) {
                return;
            }
            validateField(root, field, true);
        }, true);
        form.addEventListener("change", (event) => {
            const field = event.target;
            if (!(field instanceof HTMLElement) || !field.matches("select, input[type='checkbox'], input[type='date']")) {
                return;
            }
            validateField(root, field, true);
        });
        form.addEventListener("input", (event) => {
            const field = event.target;
            if (!(field instanceof HTMLInputElement) && !(field instanceof HTMLTextAreaElement)) {
                return;
            }
            const wrap = fieldWrap(field);
            if (wrap?.classList.contains("has-error") || wrap?.classList.contains("has-warn")) {
                validateField(root, field, true);
            }
        });
    }

    function bindPhoneMask(root) {
        qsa(root, "[data-orcamento-phone]").forEach((input) => {
            applyPhoneMask(input);
            input.addEventListener("input", () => {
                applyPhoneMask(input);
                const wrap = fieldWrap(input);
                if ((input.value || "").trim()) {
                    validateField(root, input, true);
                } else {
                    wrap?.classList.remove("has-warn");
                }
            });
        });
    }

    function bindTips(root) {
        const closeTips = (except) => {
            qsa(root, ".form-orcamento-tip.is-open").forEach((tip) => {
                if (tip !== except) {
                    tip.classList.remove("is-open");
                    tip.querySelector("[data-orcamento-tip]")?.setAttribute("aria-expanded", "false");
                }
            });
        };
        root.addEventListener("click", (event) => {
            const button = event.target.closest("[data-orcamento-tip]");
            if (!button || !root.contains(button)) {
                return;
            }
            event.preventDefault();
            const tip = button.closest(".form-orcamento-tip");
            const open = !tip?.classList.contains("is-open");
            closeTips(tip);
            tip?.classList.toggle("is-open", open);
            button.setAttribute("aria-expanded", open ? "true" : "false");
        });
        if (!document.documentElement.dataset.orcamentoTipsBound) {
            document.documentElement.dataset.orcamentoTipsBound = "true";
            document.addEventListener("click", (event) => {
                if (event.target.closest(".form-orcamento-tip")) {
                    return;
                }
                document.querySelectorAll(".form-orcamento-tip.is-open").forEach((tip) => {
                    tip.classList.remove("is-open");
                    tip.querySelector("[data-orcamento-tip]")?.setAttribute("aria-expanded", "false");
                });
            });
        }
        root.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                closeTips();
            }
        });
    }

    function setStep(root, step, scroll = true) {
        const total = qsa(root, ".form-orcamento-step").length || 1;
        const next = Math.min(Math.max(step, 1), total);
        root.dataset.currentStep = String(next);
        qsa(root, ".form-orcamento-step").forEach((el) => {
            const active = Number(el.getAttribute("data-step")) === next;
            el.classList.toggle("is-active", active);
            el.hidden = !active;
            el.toggleAttribute("inert", !active);
        });
        qsa(root, "[data-seg]").forEach((seg) => {
            const n = Number(seg.getAttribute("data-seg"));
            seg.classList.toggle("is-current", n === next);
            seg.classList.toggle("is-done", n < next);
        });
        qsa(root, "[data-pill]").forEach((pill) => {
            const n = Number(pill.getAttribute("data-pill"));
            pill.classList.toggle("is-current", n === next);
            pill.classList.toggle("is-done", n < next);
        });
        const copy = qs(root, `[data-orcamento-copy] [data-step="${next}"]`);
        const heading = qs(root, "[data-orcamento-heading]");
        const sub = qs(root, "[data-orcamento-sub]");
        const stepTitle = qs(root, "[data-orcamento-step-title]");
        const stepLabel = qs(root, "[data-orcamento-step-label]");
        if (stepLabel) {
            stepLabel.textContent = `${next} de ${total}`;
        }
        if (copy) {
            if (heading) {
                heading.textContent = copy.getAttribute("data-title") || heading.textContent;
            }
            if (sub) {
                sub.textContent = copy.getAttribute("data-sub") || sub.textContent;
            }
            if (stepTitle) {
                stepTitle.textContent = copy.getAttribute("data-title") || stepTitle.textContent;
            }
        }
        const back = qs(root, "[data-orcamento-back]");
        const nextBtn = qs(root, "[data-orcamento-next]");
        const submit = qs(root, "[data-orcamento-submit]");
        if (back) {
            back.hidden = next === 1;
        }
        if (nextBtn) {
            nextBtn.hidden = next === total;
        }
        if (submit) {
            submit.hidden = next !== total;
        }

        if (scroll && window.matchMedia("(max-width: 1080px)").matches) {
            qs(root, "[data-orcamento-heading]")?.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }

    function currentStep(root) {
        return Number(root.dataset.currentStep || 1);
    }

    function visibleControl(element) {
        return element instanceof HTMLElement
            && !element.disabled
            && !element.hidden
            && element.getClientRects().length > 0;
    }

    function stepControls(stepEl) {
        return qsa(stepEl, ".form-orcamento-field").flatMap((field) => {
            const selectTrigger = field.querySelector(".site-select-trigger");
            if (visibleControl(selectTrigger)) {
                return [selectTrigger];
            }
            return qsa(field, "input:not([type='hidden']), textarea, select").filter(visibleControl);
        });
    }

    function focusFirstStepControl(root) {
        const stepEl = qs(root, `.form-orcamento-step[data-step="${currentStep(root)}"]`);
        const first = stepEl ? stepControls(stepEl)[0] : null;
        if (first) {
            window.setTimeout(() => first.focus(), 0);
        }
    }

    function goToNextStep(root, form) {
        const current = currentStep(root);
        if (current === 1) {
            commitTemasInteresse(root);
        }
        if (!validateStep(root, current)) {
            return false;
        }
        writeDraft(root, form);
        setStep(root, current + 1);
        focusFirstStepControl(root);
        return true;
    }

    function goToPreviousStep(root, form) {
        writeDraft(root, form);
        setStep(root, currentStep(root) - 1);
        focusFirstStepControl(root);
    }

    function bindEnterAdvance(root, form) {
        form.addEventListener("keydown", (event) => {
            if (
                event.key !== "Enter"
                || event.shiftKey
                || event.ctrlKey
                || event.altKey
                || event.metaKey
                || event.isComposing
            ) {
                return;
            }

            const target = event.target;
            if (!(target instanceof HTMLElement) || target.matches("textarea, button, a")) {
                return;
            }
            if (target.closest(".site-select.is-open")) {
                return;
            }

            const stepEl = target.closest(".form-orcamento-step");
            if (!stepEl || !stepEl.classList.contains("is-active")) {
                return;
            }

            const controls = stepControls(stepEl);
            const index = controls.indexOf(target);
            if (index === -1) {
                return;
            }

            event.preventDefault();
            if (index < controls.length - 1) {
                controls[index + 1].focus();
                return;
            }

            const total = qsa(root, ".form-orcamento-step").length || 1;
            if (currentStep(root) < total) {
                goToNextStep(root, form);
                return;
            }

            qs(root, "[data-orcamento-submit]")?.click();
        });
    }

    function openOrcamentoDialog(dialog) {
        if (!dialog) {
            return;
        }
        if (typeof dialog.showModal === "function") {
            dialog.showModal();
        }
        document.body.classList.add("no-scroll");
    }

    function closeOrcamentoDialog(dialog) {
        if (!dialog) {
            return;
        }
        if (dialog.open) {
            dialog.close();
        }
        if (!document.querySelector(".orcamento-tema-pick-dialog[open]")) {
            document.body.classList.remove("no-scroll");
        }
    }

    function bindTemaPickModal(root, form) {
        const dialog = document.getElementById(`${root.id.replace(/-formulario$/, "")}-tema-pick-dialog`)
            || qs(root.parentElement || document, ".orcamento-tema-pick-dialog");
        const search = dialog?.querySelector("[data-orcamento-tema-pick-q]");
        const results = dialog?.querySelector("[data-orcamento-tema-pick-results]");
        const VISIBLE_LIMIT = 42;

        const filterTemaOptions = () => {
            if (!results) {
                return;
            }
            const query = (search?.value || "").trim().toLowerCase();
            let shown = 0;
            qsa(results, "[data-orcamento-tema-option]").forEach((chip) => {
                const label = (chip.getAttribute("data-orcamento-tema-option") || chip.textContent || "").trim().toLowerCase();
                const matches = query === "" || label.includes(query);
                if (matches && shown < VISIBLE_LIMIT) {
                    chip.hidden = false;
                    shown += 1;
                } else {
                    chip.hidden = true;
                }
            });
        };

        qs(root, "[data-orcamento-tema-pick]")?.addEventListener("click", () => {
            filterTemaOptions();
            openOrcamentoDialog(dialog);
            search?.focus();
        });

        dialog?.querySelector("[data-orcamento-tema-pick-close]")?.addEventListener("click", () => {
            closeOrcamentoDialog(dialog);
        });

        dialog?.addEventListener("click", (event) => {
            if (event.target === dialog) {
                closeOrcamentoDialog(dialog);
            }
        });

        search?.addEventListener("input", filterTemaOptions);

        results?.addEventListener("click", (event) => {
            const chip = event.target.closest("[data-orcamento-tema-option]");
            if (!chip) {
                return;
            }
            appendTemaToLivre(root, chip.getAttribute("data-orcamento-tema-option") || chip.textContent);
            writeDraft(root, form);
        });
    }

    function showSubmissionAlert(root, message) {
        const shell = qs(root, ".form-orcamento-shell");
        if (!shell) {
            return;
        }
        let alert = qs(shell, "[data-orcamento-submit-alert]");
        if (!alert) {
            alert = document.createElement("div");
            alert.className = "form-orcamento-alert msg-error";
            alert.setAttribute("data-orcamento-submit-alert", "");
            alert.setAttribute("role", "alert");
            alert.tabIndex = -1;
            shell.prepend(alert);
        }
        alert.textContent = message || "Não foi possível enviar a solicitação. Revise os dados e tente novamente.";
        alert.focus();
    }

    function trackLeadConversion(successUrl, eventName) {
        if (typeof window.siteTrackLeadConversion === "function") {
            window.siteTrackLeadConversion({
                event: eventName || "generate_lead",
                form_id: "orcamento",
                form_name: "Solicitação de orçamento",
                thankYouUrl: successUrl || window.location.href,
            });
            return;
        }
        const requestedUrl = new URL(successUrl || window.location.href, window.location.origin);
        const url = requestedUrl.origin === window.location.origin
            ? requestedUrl
            : new URL(window.location.href);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: eventName || "generate_lead",
            form_id: "orcamento",
            form_name: "Solicitação de orçamento",
            page_location: url.href,
            page_path: url.pathname,
        });
        document.dispatchEvent(new CustomEvent("motiveacao:lead-converted", {
            detail: { form: "orcamento", successUrl: url.href },
        }));
    }

    function showSuccess(root, responseResult) {
        const success = qs(root, "[data-orcamento-success]");
        const frame = qs(root, ".form-orcamento-frame");
        if (!success || !frame) {
            return;
        }
        const successUrl = responseResult.data?.success_url || window.location.pathname;
        clearDraft(root);
        frame.hidden = true;
        success.hidden = false;
        root.classList.add("is-success");
        window.history.replaceState({ orcamentoEnviado: true }, "", successUrl);
        trackLeadConversion(successUrl, responseResult.data?.conversion_event);
        success.scrollIntoView({ behavior: "smooth", block: "center" });
        success.focus({ preventScroll: true });
    }

    function bindRoot(root) {
        const form = qs(root, "form");
        if (!form || root.dataset.bound === "true") {
            return;
        }
        root.dataset.bound = "true";
        const variant = root.getAttribute("data-variant") || "page";
        const restoredStep = restoreDraft(root, form);
        const livreInit = qs(root, "[data-orcamento-tema-livre]");
        const temaFieldInit = qs(root, "[data-orcamento-tema]");
        if (livreInit && !livreInit.value.trim() && temaFieldInit?.value.trim()) {
            livreInit.value = temaFieldInit.value.trim();
        }
        syncTemaField(root);
        if (variant === "page") {
            setStep(root, restoredStep > 3 ? 1 : restoredStep, false);
        }

        form.addEventListener("input", () => writeDraft(root, form));
        form.addEventListener("change", () => writeDraft(root, form));
        bindEnterAdvance(root, form);
        bindFieldValidation(root, form);
        bindPhoneMask(root);
        bindTips(root);
        bindTemaPickModal(root, form);

        const temaLivre = qs(root, "[data-orcamento-tema-livre]");
        temaLivre?.addEventListener("input", () => {
            syncTemaField(root);
            const wrap = fieldWrap(temaLivre) || qs(root, "[data-orcamento-interest]");
            if (temaLivre.value.trim()) {
                wrap?.classList.remove("has-error");
                temaLivre.removeAttribute("aria-invalid");
            }
            writeDraft(root, form);
        });
        temaLivre?.addEventListener("blur", () => {
            commitTemasInteresse(root);
            writeDraft(root, form);
        });

        qs(root, "[data-orcamento-next]")?.addEventListener("click", () => {
            goToNextStep(root, form);
        });

        qs(root, "[data-orcamento-back]")?.addEventListener("click", () => {
            goToPreviousStep(root, form);
        });

        qs(root, "[data-orcamento-continue]")?.addEventListener("click", (event) => {
            commitTemasInteresse(root);
            if (!validateStep(root, 1)) {
                event.preventDefault();
                return;
            }
            root.dataset.currentStep = "2";
            writeDraft(root, form);
        });

        form.addEventListener("submit", (event) => {
            if (variant !== "page") {
                event.preventDefault();
                event.stopImmediatePropagation();
                return;
            }
            commitTemasInteresse(root);
            const total = qsa(root, ".form-orcamento-step").length || 1;
            const current = currentStep(root);
            if (!validateStep(root, current)) {
                event.preventDefault();
                event.stopImmediatePropagation();
                return;
            }
            for (let step = 1; step <= total; step += 1) {
                if (!validateStep(root, step)) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    setStep(root, step);
                    return;
                }
            }
            writeDraft(root, form);
        });

        if (variant === "page" && window.jQuery) {
            window.jQuery(document)
                .off("form_ajax_submit.orcamentoSite")
                .on("form_ajax_submit.orcamentoSite", (event, responseResult, action) => {
                    if (action !== "enviar_solicitacao_orcamento" || root.classList.contains("is-success")) {
                        return;
                    }
                    if (responseResult?.status === "success") {
                        showSuccess(root, responseResult);
                        return;
                    }
                    showSubmissionAlert(root, responseResult?.message);
                });
        }

        if (variant === "page" && typeof regenerateCsrfToken === "function") {
            regenerateCsrfToken(form);
        }
    }

    window.siteReady(() => {
        document.querySelectorAll("[data-orcamento-form]").forEach(bindRoot);
    });
})();
